module.exports = __webpack_public_path__ + "img/Info-icon.4ec0108b.svg";